import type { SVGProps } from 'react';

const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 3.995h-1c0-.55-.45-1-1-1s-1 .45-1 1H9c0-.55-.45-1-1-1s-1 .45-1 1H6c-1.65 0-3 1.35-3 3v11c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-11c0-1.65-1.35-3-3-3m-12 2h1c0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1h1c.55 0 1 .45 1 1v1H5v-1c0-.55.45-1 1-1m12 13H6c-.55 0-1-.45-1-1v-8h14v8c0 .55-.45 1-1 1"
    />
    <path
      fill="currentcolor"
      d="M7.29 12.285c-.19.19-.29.45-.29.71s.11.52.29.71c.19.19.45.29.71.29s.52-.11.71-.29a1 1 0 0 0 .29-.71c0-.27-.11-.52-.29-.71-.37-.37-1.04-.37-1.41 0zm0 3c-.19.19-.29.45-.29.71s.11.52.29.71c.19.19.44.29.71.29s.52-.11.71-.29a1 1 0 0 0 .29-.71c0-.27-.11-.52-.29-.71-.37-.37-1.04-.37-1.41 0zm4 0a1 1 0 0 0-.29.71c0 .27.11.52.29.71.19.19.44.29.71.29s.52-.11.71-.29a1 1 0 0 0 .29-.71c0-.27-.11-.52-.29-.71-.37-.37-1.04-.37-1.41 0zm0-3a1 1 0 0 0-.29.71c0 .27.11.52.29.71q.075.075.15.12c.05.04.11.07.17.09.06.03.12.04.19.06s.13.02.19.02.13 0 .2-.02c.06-.01.13-.03.19-.06.06-.02.12-.05.17-.09q.09-.06.15-.12a1 1 0 0 0 .29-.71c0-.27-.11-.52-.29-.71-.37-.37-1.04-.37-1.41 0m4 0a1 1 0 0 0-.29.71c0 .27.11.52.29.71.19.19.45.29.71.29s.52-.11.71-.29a1 1 0 0 0 .29-.71c0-.27-.11-.52-.29-.71-.37-.37-1.04-.37-1.41 0z"
    />
  </svg>
);
export default SvgCalendar;
